import { Controller } from "@hotwired/stimulus"

// Keeps the admin SMS conversations list current without a manual page reload,
// so a reply on an old thread bubbles back to the top as soon as it arrives.
// Plain fetch-and-swap (not turbo-frame `src`/reload) because a frame whose src
// equals the current page URL makes Turbo treat it as a self-referencing frame
// and wipe its content instead of refreshing it.
export default class extends Controller {
  static values = { interval: { type: Number, default: 15000 } }

  connect() {
    this.timer = setInterval(() => this.refresh(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  async refresh() {
    if (document.activeElement && document.activeElement.closest("form")) return

    const response = await fetch(window.location.href, {
      headers: { "X-Requested-With": "XMLHttpRequest" }
    })
    if (!response.ok) return

    const html = await response.text()
    const fresh = new DOMParser().parseFromString(html, "text/html").getElementById(this.element.id)
    if (fresh) this.element.innerHTML = fresh.innerHTML
  }
}
